interface HeroSectionProps {
  onEstimateClick: () => void;
}

export default function HeroSection({ onEstimateClick }: HeroSectionProps) {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/463876f6b9992c19145b404b14318b03.jpg"
          alt="Premium hardwood floors Maryland luxury home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 pb-24">
        <div className="max-w-2xl">
          {/* Availability Badge */}
          <div className="inline-flex items-center gap-2.5 bg-black/60 backdrop-blur-md border border-white/30 rounded-full px-5 py-2 mb-10">
            <div className="w-2 h-2 bg-gold rounded-full animate-pulse" />
            <span className="text-white font-sans text-sm font-medium tracking-wide">Limited Scheduling Available — Book Your Estimate Now</span>
          </div>

          <h1
            className="font-serif text-5xl md:text-6xl lg:text-[4.5rem] text-white font-bold leading-[1.08] mb-6"
            style={{ textShadow: '0 2px 16px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.9)' }}
          >
            Premium Hardwood Flooring
            <span className="block text-gold mt-2">Installation &amp; Refinishing</span>
            <span className="block text-white text-4xl md:text-5xl mt-2 font-semibold">in Maryland</span>
          </h1>

          <p
            className="font-sans text-lg text-white leading-relaxed mb-10 max-w-xl"
            style={{ textShadow: '0 1px 8px rgba(0,0,0,0.8)' }}
          >
            Transform your home with expertly crafted hardwood floors built to last a lifetime — elevate value, beauty, and comfort.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={onEstimateClick}
              className="flex items-center justify-center gap-2.5 px-9 py-4.5 bg-gold text-walnut font-bold rounded-xl hover:bg-gold-dark transition-all text-base whitespace-nowrap"
              style={{ paddingTop: '1.1rem', paddingBottom: '1.1rem' }}
            >
              <i className="ri-file-list-3-line" />
              Get a Free Estimate
            </button>
            <a
              href="tel:+14105550192"
              className="flex items-center justify-center gap-2.5 px-9 py-4 border-2 border-white/35 text-white font-semibold rounded-xl hover:bg-white/10 hover:border-white/60 transition-all text-base whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-phone-fill" />
              (410) 555-0192
            </a>
          </div>

          {/* Quick Stats */}
          <div className="mt-16 grid grid-cols-3 gap-0 max-w-sm">
            {[
              { num: '500+', label: 'Projects Completed' },
              { num: '15+', label: 'Years Experience' },
              { num: '4.4★', label: 'Google Rating' },
            ].map((stat, i) => (
              <div key={stat.label} className={`text-center ${i < 2 ? 'border-r border-white/20' : ''} px-4 first:pl-0`}>
                <div className="font-serif text-3xl text-gold font-bold">{stat.num}</div>
                <div className="font-sans text-xs text-white/75 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <span className="text-white font-sans text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-5 h-8 border-2 border-white/40 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
